import { ReactNode } from "react";
import { Button, ButtonProps, Spinner } from "reactstrap";
import "./index.css";

type props = {
  loading?: boolean;
  //   onClick?: () => void;
  children: ReactNode;
} & ButtonProps;

export const BaseButton = ({ loading, children, ...rest }: props) => {
  return (
    <Button
      color="primary"
      className="w-20 me-1"
      style={{
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white", // Make spinner white
      }}
      //   onClick={onClick}
      {...rest}
    >
      {loading ? (
        <span className="fade-animation">
          <Spinner
            className="me-2"
            style={{ height: "10px", width: "10px", fontSize: "2px" }}
          />
          loading
        </span>
      ) : (
        <>{children}</>
      )}
    </Button>
  );
};
